import React from "react";
import PropTypes from "prop-types";
import Isvg from "../../../vendor/react-inlinesvg";

class SectionHeader extends React.Component {
  render() {
    const { title, count } = this.props;
    let arrow = this.props.expanded
      ? "/img/up_arrow.svg"
      : "/img/down_arrow.svg";
    return (
      <div className="section-header noButton">
        <div className="section-header-title" title={title}>
          {title}
        </div>
        <div className="section-header-count-container">
          <span className="section-header-count">({count})</span>
          <span className="offScreen">
            {count === 1
              ? i18n.t("filter.result")
              : i18n.t("filter.results", { count: count })}
          </span>
          <Isvg key={arrow} src={arrow} />
        </div>
      </div>
    );
  }
}

SectionHeader.propTypes = {
  title: PropTypes.string,
  count: PropTypes.number,
  expanded: PropTypes.bool
};

SectionHeader.defaultProps = {
  title: "",
  count: 0,
  expanded: true
};

module.exports = SectionHeader;
